import { DurabilityIncidence } from '../../../../types';
export var list = [
    DurabilityIncidence.YES,
    DurabilityIncidence.NO,
];
